import { loadAsyncComponent } from 'src/components/AsyncComponent';

export const DeleteProjectFolderPopup = loadAsyncComponent(
  () => import(/* webpackChunkName: "DeleteProjectFolderPopup" */ './Container'),
  'popup'
);
